export const REGIONS = [
  {
    code: 'US',
    name: 'USA',
    signLang: 'ASL',
    ttsLang: 'en-US',
    flagUrl: 'https://flagcdn.com/w160/us.png',
  },
  {
    code: 'MX',
    name: 'México',
    signLang: 'LSM',
    ttsLang: 'es-MX',
    flagUrl: 'https://flagcdn.com/w160/mx.png',
  },
  {
    code: 'PA',
    name: 'Panamá',
    signLang: 'LSP',
    ttsLang: 'es-PA', // some browsers fallback to es-ES automatically
    flagUrl: 'https://flagcdn.com/w160/pa.png',
  },
  {
    code: 'BR',
    name: 'Brasil',
    signLang: 'LIBRAS',
    ttsLang: 'pt-BR',
    flagUrl: 'https://flagcdn.com/w160/br.png',
  },
  {
    code: 'IN',
    name: 'India',
    signLang: 'ISL',
    ttsLang: 'en-IN', // fallback en-US if voice missing
    flagUrl: 'https://flagcdn.com/w160/in.png',
  },
];

export const DEFAULT_REGION = 'US';
export const DEFAULT_CONTEXT_MODE = 'general'; // 'general' | 'hospitality'

export const findRegion = (code) =>
  REGIONS.find((r) => r.code === code) || REGIONS[0];
